export enum GemzActionType {
  UpdateFeed = 'gemz/updateFeed',
  BringGemToTop = 'gemz/bringGemToTop',
  UpdateFeedState = 'gemz/updateFeedState',
}
